/* eslint-disable default-case */
import * as React from 'react';
import { GridComponent, ColumnsDirective, ColumnDirective, Toolbar, ExcelExport, PdfExport, Page, DetailRow, Filter, Inject, Sort, Group } from '@syncfusion/ej2-react-grids';
import { SampleBase } from './sample-base';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify';
import * as CustomJS from '../Custom';
import _ from 'underscore/underscore-min';
import BlockUi from '@availity/block-ui';
import { random, isUndefined } from 'underscore';
import LavoriInCorso from '../assets/LavoriInCorso2.jpg';

// =============================================
// CONFIGURAZIONE GRUPPI COMPAGNIA
// Ogni elemento definisce un gruppo di primo livello che raggruppa
// più compagnie (identificate tramite id_compagnia) in un'unica riga
// con totalizzazione e dettaglio espandibile al secondo livello.
// Per aggiungere/modificare/rimuovere gruppi, basta editare questo array.
// =============================================
const GRUPPI_COMPAGNIA = [
    { descrizione: 'UNIPOL ASSICURAZIONI S.P.A.', idCompagnie: [78, 57] },
    { descrizione: 'ALLIANZ S.P.A.', idCompagnie: [65, 44] },
    { descrizione: 'GENERALI ITALIA S.P.A.', idCompagnie: [32, 61] },
];

const TARGET_COMPAGNIE = [
    { id: [78, 57], target: 14000 },
    { id: [32, 61], target: 10000 },
    { id: [65, 44], target: 3500 },
    { id: [39], target: 3000 },
    { id: [56, 34], target: 1500 },
    { id: [37], target: 750 },
    { id: [63], target: 800 },
    { id: [62, 79], target: 50 },
    { id: [55], target: 1000 },
    { id: [69], target: 200 },
    { id: [269, 267, 80], target: 300 },
    { id: [52], target: 4000 },
    { id: [81], target: 1500 },
    { id: [36], target: 10 },
    { id: [49], target: 15 }
];

function headerTemplate(props) {    
    return (<div>
         <span style={{ fontSize: '0.95vw', fontWeight: 'bolder' }}>{props.headerText}</span>
    </div>);
}

function fieldTemplate(props) {       
    let colore = props.column.field === 'NominativoReferente' ? '#133B95' : (props.column.field === 'AssegnAnnoCorrSuAnnoPrec' && props.AssegnAnnoPrec > props.AssegnAnnoCorr) ? 'red' : 'purple';
    return (        
         <div><span style={{ fontSize: '1.0vw', color: colore, fontWeight: 'bold'}}>{props[props.column.field]}</span></div>
    );
}

function fieldTemplateDetail(props) {       
    let colore = props.column.field === 'DescrizioneCompagnia' || props.column.field === 'ReferenteAttuale' ? '#133B95' : 'purple';
    return (        
         <div><span style={{ fontSize: '0.95vw', color: colore, fontWeight: 'bold'}}>{props[props.column.field]}</span></div>
    );
}

function fieldTemplateTarget(props) {

    const val = props.ValoreTarget || 0;

    let bg = '#4DFF4D';

    if (val < -20) bg = '#B30000';
    else if (val < -10) bg = '#FF9900';
    else if (val < 0) bg = 'yellow';

    return (
        <div>
            <span style={{
                fontSize: '1.0vw',
                fontWeight: 'bold',
                color: 'black',
                padding: '3px 6px',
                borderRadius: '4px'
            }}>
                {val.toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}%
            </span>
        </div>
    );
}

function fieldTemplatePercentuale(props) {
    const val = props[props.column.field] || 0;

    return (
        <div>
            <span style={{
                fontSize: '1.0vw',
                fontWeight: 'bold',
                color: 'black'
            }}>
                {val.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%
            </span>
        </div>
    );
}

function fieldTemplateTargetCompagnia(props) {
    const val = props.SinistriTargetCompagnia || '-';
    const percentuale = props.ValoreTarget || 0;

    return (
        <div>
            <span style={{
                fontSize: '1.0vw',
                fontWeight: 'bold',
                color: 'black',
                padding: '3px 6px',
                borderRadius: '4px'
            }}>
                {val} <span style={{
                    fontSize: '0.77vw',
                    fontWeight: 'bold',
                    color: 'black'
                }}>({percentuale.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%)</span>
            </span>
        </div>
    );
}

/**
 * Elabora i dati grezzi dall'API applicando la configurazione dei gruppi.
 * - Le compagnie il cui id_compagnia rientra in un gruppo vengono aggregate in una riga master
 *   con totalizzazione delle colonne numeriche e dettaglio espandibile.
 * - Le compagnie non raggruppate restano come righe singole di primo livello.
 * 
 * @param {Array} rawData - Dati grezzi dall'API (prima della formattazione stringhe)
 * @param {Array} gruppiConfig - Array di configurazione gruppi (GRUPPI_COMPAGNIA)
 * @returns {Array} DataSource pronto per la griglia
 */
function elaboraDatiConGruppi(rawData, gruppiConfig) {
    // DEBUG: Logga la prima riga per capire i nomi dei campi dal server
    if (rawData.length > 0) {
        console.log('[GRUPPI_COMPAGNIA] Campi disponibili dal server:', Object.keys(rawData[0]));
        console.log('[GRUPPI_COMPAGNIA] Prima riga completa:', JSON.stringify(rawData[0]));
    }

    // Raccoglie tutti gli id_compagnia che appartengono ad almeno un gruppo
    // Converte tutto a Number per evitare mismatch string/number dal server
    const idRaggruppati = new Set();
    gruppiConfig.forEach(g => {
        g.idCompagnie.forEach(id => idRaggruppati.add(Number(id)));
    });

    const risultato = [];

    // 1. Crea le righe master per ogni gruppo configurato
    gruppiConfig.forEach(gruppo => {
        const idSet = new Set(gruppo.idCompagnie.map(Number));
        const compagnieDelGruppo = rawData.filter(elm => {
            // Cerca il campo id_compagnia in modo case-insensitive
            const idField = Object.keys(elm).find(k => k.toLowerCase() === 'id_compagnia' || k.toLowerCase() === 'idcompagnia');
            const idVal = idField ? Number(elm[idField]) : NaN;
            return idSet.has(idVal);
        });

        console.log(`[GRUPPI_COMPAGNIA] Gruppo "${gruppo.descrizione}": cercati id [${gruppo.idCompagnie.join(',')}], trovate ${compagnieDelGruppo.length} compagnie`);

        if (compagnieDelGruppo.length === 0) return; // Nessuna compagnia trovata per questo gruppo, salta

        // Totalizzazione dei valori numerici grezzi
        const totSinistriAnnoCorr = _.reduce(compagnieDelGruppo, (sum, c) => sum + (c.SinistriAnnoCorrente || 0), 0);
        const totSinistriAnnoPrec = _.reduce(compagnieDelGruppo, (sum, c) => sum + (c.SinistriAnnoPrecedente || 0), 0);
        const totNumS_Corr = _.reduce(compagnieDelGruppo, (sum, c) => sum + (c.NumSinistriTipoS_AnnoCorrente || 0), 0);
        const totNumI_Corr = _.reduce(compagnieDelGruppo, (sum, c) => sum + (c.NumSinistriTipoI_AnnoCorrente || 0), 0);
        const totNumC_Corr = _.reduce(compagnieDelGruppo, (sum, c) => sum + (c.NumSinistriTipoC_AnnoCorrente || 0), 0);
        const totNumS_Prec = _.reduce(compagnieDelGruppo, (sum, c) => sum + (c.NumSinistriTipoS_AnnoPrecedente || 0), 0);
        const totNumI_Prec = _.reduce(compagnieDelGruppo, (sum, c) => sum + (c.NumSinistriTipoI_AnnoPrecedente || 0), 0);
        const totNumC_Prec = _.reduce(compagnieDelGruppo, (sum, c) => sum + (c.NumSinistriTipoC_AnnoPrecedente || 0), 0);
        const totProperty_Corr = _.reduce(compagnieDelGruppo, (sum, c) => sum + (c.NumSinistriProperty_AnnoCorrente || 0), 0);
        const totRC_Corr = _.reduce(compagnieDelGruppo, (sum, c) => sum + (c.NumSinistriRC_AnnoCorrente || 0), 0);
        const totATP_CTP_Corr = _.reduce(compagnieDelGruppo, (sum, c) => sum + (c.NumSinistriATP_CTP_AnnoCorrente || 0), 0);

        // Formatta le stringhe per il dettaglio (secondo livello)
        const dettaglioFormattato = compagnieDelGruppo.map(elm => ({
            ...elm,
            SinistriAnnoCorrente: `${(elm.SinistriAnnoCorrente || 0).toLocaleString('it-IT')} (S=${(elm.NumSinistriTipoS_AnnoCorrente || 0).toString()}, I=${(elm.NumSinistriTipoI_AnnoCorrente || 0).toString()}, C=${(elm.NumSinistriTipoC_AnnoCorrente || 0)})`,
            SinistriAnnoPrecedente: `${(elm.SinistriAnnoPrecedente || 0).toLocaleString('it-IT')} (S=${(elm.NumSinistriTipoS_AnnoPrecedente || 0).toString()}, I=${(elm.NumSinistriTipoI_AnnoPrecedente || 0).toString()}, C=${(elm.NumSinistriTipoC_AnnoPrecedente || 0)})`,
        }));

        const primoElemento = compagnieDelGruppo[0];

        const totaleAssegnatiGruppo = _.reduce(
            compagnieDelGruppo,
            (sum, c) => sum + Number(c.SinistriAnnoCorrente || 0),
            0
        );

        const valoreTargetGruppo = calcolaValoreTarget(
            primoElemento,
            totaleAssegnatiGruppo
        );

        // Riga master del gruppo
        risultato.push({
            _isGruppo: true,
            _dettaglioCompagnie: dettaglioFormattato,
            DescrizioneCompagnia: gruppo.descrizione,
            ReferenteAttuale: compagnieDelGruppo[0]?.ReferenteAttuale || '',
            SinistriAnnoCorrente: `${totSinistriAnnoCorr.toLocaleString('it-IT')} (S=${totNumS_Corr}, I=${totNumI_Corr}, C=${totNumC_Corr})`,
            SinistriAnnoPrecedente: `${totSinistriAnnoPrec.toLocaleString('it-IT')} (S=${totNumS_Prec}, I=${totNumI_Prec}, C=${totNumC_Prec})`,
            // Mantieni i totali numerici grezzi per il confronto colore nel template
            _totSinistriAnnoCorr: totSinistriAnnoCorr,
            _totSinistriAnnoPrec: totSinistriAnnoPrec,
            ValoreTarget: valoreTargetGruppo,
            SinistriTargetCompagnia: getSinistriTargetCompagnia(gruppo.idCompagnie[0]),
            DiCuiProperty: calcolaPercentualeDiCui(totProperty_Corr, totSinistriAnnoCorr),
            DiCuiRC: calcolaPercentualeDiCui(totRC_Corr, totSinistriAnnoCorr),
            DiCuiATP_CTP: calcolaPercentualeDiCui(totATP_CTP_Corr, totSinistriAnnoCorr),
        });
    });

    // 2. Aggiungi le righe singole (compagnie NON raggruppate)
    rawData.forEach(elm => {
        const idField = Object.keys(elm).find(k => k.toLowerCase() === 'id_compagnia' || k.toLowerCase() === 'idcompagnia');
        const idVal = idField ? Number(elm[idField]) : NaN;
        if (idRaggruppati.has(idVal)) return; // Già inclusa in un gruppo

        risultato.push({
            ...elm,
            _isGruppo: false,
            _dettaglioCompagnie: null,
            DescrizioneCompagnia: elm.DescrizioneCompagnia,
            ReferenteAttuale: elm.ReferenteAttuale,
            SinistriAnnoCorrente: `${(elm.SinistriAnnoCorrente || 0).toLocaleString('it-IT')} (S=${(elm.NumSinistriTipoS_AnnoCorrente || 0).toString()}, I=${(elm.NumSinistriTipoI_AnnoCorrente || 0).toString()}, C=${(elm.NumSinistriTipoC_AnnoCorrente || 0)})`,
            SinistriAnnoPrecedente: `${(elm.SinistriAnnoPrecedente || 0).toLocaleString('it-IT')} (S=${(elm.NumSinistriTipoS_AnnoPrecedente || 0).toString()}, I=${(elm.NumSinistriTipoI_AnnoPrecedente || 0).toString()}, C=${(elm.NumSinistriTipoC_AnnoPrecedente || 0)})`,
        });
    });

    console.log(`[GRUPPI_COMPAGNIA] Risultato finale: ${risultato.length} righe (${risultato.filter(r => r._isGruppo).length} gruppi, ${risultato.filter(r => !r._isGruppo).length} singole)`);
    return risultato;
}

function getGiornoAnno() {
    const oggi = new Date();
    const start = new Date(oggi.getFullYear(), 0, 0);
    return Math.floor((oggi - start) / 86400000);
}

/**
 * Percentuale di un conteggio "Di cui" (Property/RC/ATP-CTP) rispetto al totale
 * dei sinistri assegnati nell'anno corrente (stessa base usata per SinistriAnnoCorrente).
 */
function calcolaPercentualeDiCui(conteggio, totale) {
    const tot = Number(totale || 0);
    if (!tot) return 0;
    return Math.round((Number(conteggio || 0) / tot) * 100 * 100) / 100;
}

function getSinistriTargetCompagnia(idCompagnia) {
    const id = Number(idCompagnia);
    const match = TARGET_COMPAGNIE.find(c => c.id.map(Number).includes(id));
    if (!match) return '-';
    return Number(match.target || 0).toLocaleString('it-IT');
}

/**
 * Calcola il target complessivo per la riga TOTALE applicando la regola:
 * - Entrate di TARGET_COMPAGNIE i cui ID corrispondono ad un gruppo in GRUPPI_COMPAGNIA → target contato una sola volta
 * - Tutte le altre entrate multi-ID → target × numero di ID (ogni compagnia ha il suo target individuale)
 */
function calcolaTotaleTargetComplessivo() {
    const idRaggruppati = new Set();
    GRUPPI_COMPAGNIA.forEach(g => g.idCompagnie.forEach(id => idRaggruppati.add(Number(id))));

    return TARGET_COMPAGNIE.reduce((sum, entry) => {
        const ids = entry.id.map(Number);
        const isRaggruppato = ids.length > 1 && ids.every(id => idRaggruppati.has(id));
        const multiplier = isRaggruppato ? 1 : ids.length;
        return sum + Number(entry.target || 0) * multiplier;
    }, 0);
}

function calcolaValoreTarget(row, totaleGruppo = null) {

    const idCompagnia = Number(row.id_compagnia);

    const match = TARGET_COMPAGNIE.find(c =>
        c.id.map(Number).includes(idCompagnia)
    );

    if (!match) {
        console.warn('TARGET NON TROVATO per id:', idCompagnia);
        return 0;
    }

    const target = Number(match.target || 0);

    const giornoAnno = getGiornoAnno();

    const X = (target / 365) * giornoAnno;

    const assegnati = totaleGruppo !== null
        ? Number(totaleGruppo)
        : Number(row.SinistriAnnoCorrente);

    if (!assegnati || assegnati === 0) {
        console.warn('ASSEGNATI ZERO per id:', idCompagnia, row);
        return 0;
    }

    const risultato = X > 0 ? (((assegnati/ X) - 1) * 100) : 0;

    return Math.round(risultato * 100) / 100;
}

export default class GridReferentiTecnici extends SampleBase {
    constructor() {
        super(...arguments);  
        this.toolbarOptions = ['ExcelExport', 'PdfExport', 'Search'];              
        this.groupOptions = { showDropArea: false, showUngroupButton: false, columns: ['NominativoReferente'], captionTemplate: this.groupHeaderTemplate.bind(this) };     
        this.toggleBlocking = this.toggleBlocking.bind(this);
        this.hasGruppi = GRUPPI_COMPAGNIA.length > 0;
    }   
    state = {
        blocking: false,  
    }   
    toggleBlocking() {
        this.setState({blocking: !this.state.blocking});
    }
    onQueryCellInfo(args) { 
    }    
    onDatabound(args) {       
        const headerTable = this.gridInstance.getHeaderTable();
        if (headerTable) {
            const headers = headerTable.querySelectorAll('th');
            for (let ind = 0; ind < headers.length && ind <= 8; ind++) {
                headers[ind].style.backgroundColor = 'Linen';
            }
        }

        const now = new Date();
        const testoElem = document.getElementById('TestoDatiAggiornati');
        if (testoElem) {
            testoElem.innerText = `Dati aggiornati al ${now.getDate().toString().padStart(2,'0')}/` +
                                  `${(now.getMonth()+1).toString().padStart(2,'0')}/${now.getFullYear()} alle ore ` +
                                  `${now.getHours()}:${now.getMinutes().toString().padStart(2,'0')}`;
        }

        // Nasconde l'icona di espansione dove non serve
        // Se non ci sono gruppi: nasconde interamente la colonna detail (griglia identica all'originale)
        // Se ci sono gruppi: nasconde solo sulle righe singole (non gruppo)
        if (!this.hasGruppi) {
            // Nasconde la colonna detail nell'header
            const detailHeader = document.querySelector('#GridReferentiCompagnia .e-detailheadercell');
            if (detailHeader) detailHeader.style.display = 'none';
            // Nasconde tutte le celle detail nelle righe
            document.querySelectorAll('#GridReferentiCompagnia .e-detailrowcollapse, #GridReferentiCompagnia .e-detailrowexpand').forEach(cell => {
                cell.style.display = 'none';
            });
        } else {
            const rows = this.gridInstance.getRows();
            const dataSource = this.gridInstance.getCurrentViewRecords();
            rows.forEach((row, idx) => {
                if (dataSource[idx] && !dataSource[idx]._isGruppo) {
                    const detailCell = row.querySelector('.e-detailrowcollapse');
                    if (detailCell) {
                        detailCell.classList.remove('e-detailrowcollapse');
                        detailCell.innerHTML = '';
                        detailCell.style.cursor = 'default';
                    }
                }
            });
        }
    }
    onRowDatabound(args) {   
        if (args.data.DescrizioneCompagnia && args.data.DescrizioneCompagnia.indexOf('TOTALE') > -1) {
            args.row.bgColor = 'gold';
        }
        if (args.data._isGruppo) {
            args.row.style.backgroundColor = '#E8EAF6';
            args.row.style.fontWeight = 'bold';
        }
    }
    groupHeaderTemplate(props) {       
        return ( props.items[0].NominativoReferente === 'TOTALE' ? <span style={{ fontSize: '1.3vw', fontWeight: 'bold', color:'#133B95' }}>{props.items[0].NominativoReferente}</span> :
                  <span style={{ fontSize: '1.3vw', fontWeight: 'bold', color:'#133B95' }}>{props.items[0].NominativoReferente}</span>
            );
    }
    toolbarClick(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-pdfexport':
                this.gridInstance.pdfExport();
                break;
            case 'e-excelexport':
                this.gridInstance.excelExport();
                break;
            case 'e-csvexport':
                this.gridInstance.csvExport();
                break;
        }
    }

    onDataBoundDetail(args) {
        // Colora le intestazioni della griglia dettaglio in azzurro molto chiaro
        document.querySelectorAll('.e-detailrow .e-gridheader .e-columnheader').forEach(headerRow => {
            for (let ind = 0; ind < headerRow.children.length; ind++) {
                headerRow.children[ind].style.backgroundColor = '#E3F2FD';
            }
        });
    }

    /**
     * Template per il dettaglio (secondo livello): compagnie appartenenti al gruppo.
     * Viene renderizzato solo per le righe con _isGruppo === true.
     */
    detailTemplate(props) {
        if (!props._isGruppo || !props._dettaglioCompagnie || props._dettaglioCompagnie.length === 0) {
            return <div></div>;
        }

        const compagnie = props._dettaglioCompagnie;
        return (
            <div style={{ padding: '10px 20px' }}>
                <GridComponent dataSource={compagnie} allowSelection={false} enableHover={false} allowTextWrap={true}
                    allowSorting={true} allowFiltering={false} enableAltRow={true} gridLines='Both'
                    dataBound={this.onDataBoundDetail.bind(this)}>
                    <ColumnsDirective>
                        <ColumnDirective field='DescrizioneCompagnia' headerText='Compagnia' width='20%' headerTemplate={headerTemplate} template={fieldTemplateDetail} textAlign='Left' clipMode="EllipsisWithTooltip"></ColumnDirective>
                        <ColumnDirective field='ReferenteAttuale' headerText='Referente Attuale' headerTemplate={headerTemplate} template={fieldTemplateDetail} textAlign='Center' clipMode="EllipsisWithTooltip"></ColumnDirective>
                        <ColumnDirective field='SinistriAnnoPrecedente' headerText="Assegnati nell'anno precedente (allo stesso giorno)" width='30%' headerTemplate={headerTemplate} template={(detailProps) => {
                                const match = detailProps.SinistriAnnoPrecedente.match(/^([\d.]+)\s*(\(.*\))$/);
                                if (!match) return detailProps.SinistriAnnoPrecedente;
                                const total = match[1];
                                const details = match[2];
                                return (
                                    <span>
                                        <span style={{fontSize:'1.4em', fontWeight:'bolder', color:'black'}}>{total}</span>
                                        <span style={{fontSize:'1.1em', fontWeight:'800', color:'grey', marginLeft:'4px'}}>{details}</span>
                                    </span>
                                );
                            }} textAlign='Center'></ColumnDirective>
                        <ColumnDirective field='SinistriAnnoCorrente' headerText="Assegnati nell'anno corrente" headerTemplate={headerTemplate} template={(detailProps) => {
                                const match = detailProps.SinistriAnnoCorrente.match(/^([\d.]+)\s*(\(.*\))$/);
                                if (!match) return detailProps.SinistriAnnoCorrente;
                                const total = match[1];
                                const details = match[2];
                                const previousTotal = parseInt(detailProps.SinistriAnnoPrecedente.match(/^([\d.]+)/)?.[1]?.replace(/\./g, '') || '0', 10);
                                const currentTotal = parseInt(total.replace(/\./g, ''), 10);
                                const color = currentTotal >= previousTotal ? 'green' : 'red';
                                return (
                                    <span>
                                        <span style={{fontSize:'1.4em', fontWeight:'bolder', color}}>{total}</span>
                                        <span style={{fontSize:'1.1em', fontWeight:'800', color:'grey', marginLeft:'4px'}}>{details}</span>
                                    </span>
                                );
                            }} textAlign='Center'></ColumnDirective>
                    </ColumnsDirective>
                    <Inject services={[Sort, Filter]} />
                </GridComponent>
            </div>
        );
    }

    render() {
        return (<React.Fragment> 
                    <BlockUi tag='div' id='blockUI1' blocking={this.state.blocking} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}>           
                        <GridComponent id="GridReferentiCompagnia" ref={grid => this.gridInstance = grid} toolbar={this.toolbarOptions} allowSelection={false} enableHover={false} allowTextWrap={true}
                                    allowPaging={false} allowSorting={false} allowFiltering={false} allowExcelExport={true} allowPdfExport={true} queryCellInfo={this.onQueryCellInfo.bind(this)} 
                                    dataBound={this.onDatabound.bind(this)} rowDataBound={this.onRowDatabound.bind(this)} toolbarClick={this.toolbarClick.bind(this)} 
                                    detailTemplate={this.detailTemplate.bind(this)}
                                    allowGrouping={false} enableAltRow={false} pageSettings={{ pageCount: 5, pageSize: 15, pageSizes: false }}>
                            <ColumnsDirective>                            
                                <ColumnDirective field='DescrizioneCompagnia' headerText='Compagnia' width='16%' headerTemplate={headerTemplate} template={fieldTemplate} textAlign='Left' filter={this.Filter} clipMode="EllipsisWithTooltip"></ColumnDirective>
                                <ColumnDirective field='ReferenteAttuale' headerText='Referente Attuale' width='9%' headerTemplate={headerTemplate} template={fieldTemplate} textAlign='Center' filter={this.Filter} clipMode="EllipsisWithTooltip"></ColumnDirective>
                                <ColumnDirective field='SinistriAnnoPrecedente' headerText="Assegnati nell'anno precedente (allo stesso giorno)" width='16%' headerTemplate={headerTemplate} template={(props) => {
                                        const match = props.SinistriAnnoPrecedente.match(/^([\d.]+)\s*(\(.*\))$/);
                                        if (!match) return props.SinistriAnnoPrecedente;
                                        const total = match[1];
                                        const details = match[2];
                                        return (
                                            <span>
                                                <span style={{fontSize:'1.7em', fontWeight:'bolder', color:'black'}}>{total}</span>
                                                <span style={{fontSize:'1.3em', fontWeight:'800', color:'#6E6E6E', marginLeft:'4px'}}>{details}</span>
                                            </span>
                                        );
                                    }} textAlign='Center'></ColumnDirective>
                                <ColumnDirective field='SinistriAnnoCorrente' headerText="Assegnati nell'anno corrente" width='16%' headerTemplate={headerTemplate} template={(props) => {
                                        const match = props.SinistriAnnoCorrente.match(/^([\d.]+)\s*(\(.*\))$/);
                                        if (!match) return props.SinistriAnnoCorrente;
                                        const total = match[1];
                                        const details = match[2];
                                        const previousTotal = parseInt(props.SinistriAnnoPrecedente.match(/^([\d.]+)/)?.[1]?.replace(/\./g, '') || '0', 10);
                                        const currentTotal = parseInt(total.replace(/\./g, ''), 10);
                                        const color = currentTotal >= previousTotal ? 'green' : 'red';
                                        return (
                                            <span>
                                                <span style={{fontSize:'1.7em', fontWeight:'bolder', color}}>{total}</span>
                                                <span style={{fontSize:'1.3em', fontWeight:'800', color:'#6E6E6E', marginLeft:'4px'}}>{details}</span>
                                            </span>
                                        );
                                    }} textAlign='Center'></ColumnDirective>
                                <ColumnDirective field='DiCuiProperty' headerText='Di cui Property' width='8%' headerTemplate={headerTemplate} template={fieldTemplatePercentuale} textAlign='Center' filter={this.Filter} clipMode="EllipsisWithTooltip"></ColumnDirective>
                                <ColumnDirective field='DiCuiRC' headerText='Di cui RC' width='8%' headerTemplate={headerTemplate} template={fieldTemplatePercentuale} textAlign='Center' filter={this.Filter} clipMode="EllipsisWithTooltip"></ColumnDirective>
                                <ColumnDirective field='DiCuiATP_CTP' headerText='Di cui ATP/CTP' width='8%' headerTemplate={headerTemplate} template={fieldTemplatePercentuale} textAlign='Center' filter={this.Filter} clipMode="EllipsisWithTooltip"></ColumnDirective>
                                <ColumnDirective field='SinistriTargetCompagnia' headerText='Sinistri Target Compagnia (Anno)' width='19%' headerTemplate={headerTemplate} template={fieldTemplateTargetCompagnia} textAlign='Center' filter={this.Filter} clipMode="EllipsisWithTooltip"></ColumnDirective>
                            </ColumnsDirective>                       
                            <Inject services={[Toolbar, ExcelExport, PdfExport, DetailRow, Filter, Sort, Group, Page]}/>                    
                        </GridComponent> 
                    </BlockUi>                                  
            </React.Fragment>);
    }
    componentDidMount() {
        this.caricaDati();
    }
    caricaDati() {
        this.toggleBlocking();
        CustomJS.callAPI(
            `${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/referentiCompagnia/[NO]/[NO]/[NO]/[NO]/[NO]/[NO]`,
            '',
            'GET',
            '',
            retData => {
                this.toggleBlocking();
                try {
                    console.log(`[GRUPPI_COMPAGNIA] Ricevute ${retData.length} righe dal server`);

                    // 🔹 1. MAPPA ID -> GRUPPO (O(1))
                    const mappaGruppi = {};
                    GRUPPI_COMPAGNIA.forEach(g => {
                        g.idCompagnie.forEach(id => {
                            mappaGruppi[id] = g;
                        });
                    });

                    // 🔹 2. TOTALI PER GRUPPO (una sola passata)
                    const totaliPerGruppo = {};
                    const totaliSingoli = {};

                    retData.forEach(row => {
                        const id = Number(row.id_compagnia);
                        const valore = Number(row.SinistriAnnoCorrente || 0);
                        const gruppo = mappaGruppi[id];

                        if (gruppo) {
                            const key = gruppo.descrizione;

                            if (!totaliPerGruppo[key]) {
                                totaliPerGruppo[key] = 0;
                            }

                            totaliPerGruppo[key] += valore;
                        } else {
                            totaliSingoli[id] = valore;
                        }
                    });

                    // 🔹 3. CALCOLO VALORE TARGET E SINISTRI TARGET GIORNO CORRENTE
                    const giornoAnno = getGiornoAnno();
                    retData.forEach(row => {
                        // La riga TOTALE viene gestita separatamente sotto
                        if (row.DescrizioneCompagnia && row.DescrizioneCompagnia.indexOf('TOTALE') > -1) return;

                        const id = row.id_compagnia;
                        const gruppo = mappaGruppi[id];

                        let totaleRiferimento;

                        if (gruppo) {
                            totaleRiferimento = totaliPerGruppo[gruppo.descrizione];
                        } else {
                            totaleRiferimento = totaliSingoli[id];
                        }

                        row.ValoreTarget = calcolaValoreTarget(row, totaleRiferimento);
                        row.SinistriTargetCompagnia = getSinistriTargetCompagnia(id);
                        row.DiCuiProperty = calcolaPercentualeDiCui(row.NumSinistriProperty_AnnoCorrente, row.SinistriAnnoCorrente);
                        row.DiCuiRC = calcolaPercentualeDiCui(row.NumSinistriRC_AnnoCorrente, row.SinistriAnnoCorrente);
                        row.DiCuiATP_CTP = calcolaPercentualeDiCui(row.NumSinistriATP_CTP_AnnoCorrente, row.SinistriAnnoCorrente);
                    });

                    // Calcolo riga TOTALE: target complessivo con regola gruppi
                    const totaleRow = retData.find(row =>
                        row.DescrizioneCompagnia && row.DescrizioneCompagnia.indexOf('TOTALE') > -1
                    );
                    if (totaleRow) {
                        const totalTarget = calcolaTotaleTargetComplessivo();
                        const sinistriTargetGiornoTotale = (totalTarget / 365) * giornoAnno;
                        const totaleAssegnati = Number(totaleRow.SinistriAnnoCorrente || 0);
                        totaleRow.SinistriTargetCompagnia = totalTarget.toLocaleString('it-IT');
                        totaleRow.ValoreTarget = sinistriTargetGiornoTotale > 0
                            ? Math.round((((totaleAssegnati / sinistriTargetGiornoTotale) - 1) * 100) * 100) / 100
                            : 0;
                        totaleRow.DiCuiProperty = calcolaPercentualeDiCui(totaleRow.NumSinistriProperty_AnnoCorrente, totaleAssegnati);
                        totaleRow.DiCuiRC = calcolaPercentualeDiCui(totaleRow.NumSinistriRC_AnnoCorrente, totaleAssegnati);
                        totaleRow.DiCuiATP_CTP = calcolaPercentualeDiCui(totaleRow.NumSinistriATP_CTP_AnnoCorrente, totaleAssegnati);
                    }

                    // 🔹 4. ELABORAZIONE GRID (intatta)
                    const GridData = elaboraDatiConGruppi(retData, GRUPPI_COMPAGNIA);
                    this.gridInstance.dataSource = GridData;

                } catch (ex) {
                    console.error('[GRUPPI_COMPAGNIA] Errore in elaboraDatiConGruppi:', ex);

                    // 🔻 FALLBACK (NON TOCCATO)
                    let GridDataFallback = [];
                    retData.forEach((elm) => {
                        elm.SinistriAnnoCorrente = `${elm.SinistriAnnoCorrente.toLocaleString('it-IT')} (S=${elm.NumSinistriTipoS_AnnoCorrente.toString()}, I=${elm.NumSinistriTipoI_AnnoCorrente.toString()}, C=${elm.NumSinistriTipoC_AnnoCorrente})`;
                        elm.SinistriAnnoPrecedente = `${elm.SinistriAnnoPrecedente.toLocaleString('it-IT')} (S=${elm.NumSinistriTipoS_AnnoPrecedente.toString()}, I=${elm.NumSinistriTipoI_AnnoPrecedente.toString()}, C=${elm.NumSinistriTipoC_AnnoPrecedente})`;
                        GridDataFallback.push(elm);
                    });

                    this.gridInstance.dataSource = GridDataFallback;
                }
            },
            error => {
                this.toggleBlocking();
                let messaggio = (_.isString(error) && error.indexOf('Not Found')) > -1
                    ? CustomJS.messaggioAPIBackendNonTrovata
                    : CustomJS.messaggioNoBackend;

                toast.warn(messaggio, {
                    containerId: 'toastContainer1',
                    position: "top-right",
                    autoClose: 8000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                    newestOnTop: true,
                    rtl: false,
                    pauseOnFocusLoss: true
                });
            },
            true,
            false
        );
    }
}